<template>
  <v-container
    fluid
    class="security-container"
  >
    <h1>Securities</h1>
    <br>

    <v-card>
      <v-card-title class="card-title">
        <span class="headline white--text text-uppercase">List</span>
      </v-card-title>

      <v-card-text>
        <security-list
          v-if="isLoaded"
          :securities="securities"
          :get-securities="getSecurities"
        />
        <div
          v-else
          class="load-wrapper"
        >
          <v-progress-circular
            indeterminate
            color="primary"
          />
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { SecurityList } from '@/components/securities';

export default {
  name: 'Securities',
  components: {
    SecurityList,
  },
  data() {
    return {
      securities: [],
      isLoaded: false,
    };
  },
  mounted() {
    this.getSecurities();
  },
  methods: {
    ...mapActions([
      'getAllSecurities',
    ]),
    getSecurities() {
      this.getAllSecurities().then((securities) => {
        this.securities = securities;
        this.isLoaded = true;
      }).catch(() => {
        this.securities = [];
        this.isLoaded = true;
      });
    },
  },

};
</script>

<style lang='scss' scoped>
.load-wrapper {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/securities/Securities.vue